module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("© 2008 by Weider History Group, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Once a Marine: An Iraq War Tank Commander’s Inspirational Memoir of Combat, Courage, and Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("All rights reserved. No part of this work may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Cataloging-in-Publication Data is available from the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("ISBN 13: 978-1-932714-47-0")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Digital Edition ISBN: 978-1-61121-037-8")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 / Second edition, first printing")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "SB",
      "src": "images/SB.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Savas Beatie LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("521 Fifth Avenue, Suite 1700")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("New York, NY 10175")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Phone: 610-853-9131")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "horse",
      "src": "images/horse.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("In cooperation with Weider History Group")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Photos courtesy of Nick and April Popaditch unless otherwise noted.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText4"
  }, [_vm._v("Savas Beatie titles are available at special discounts for bulk purchases in the United States by corporations, institutions, and other organizations. For more details, please contact Special Sales, P.O. Box 4527, El Dorado Hills, CA 95762. You may also e-mail us at sales@savasbeatie.com, or click over for an informative visit to our website at "), _c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_vm._v("www.savasbeatie.com")]), _vm._v(" for additional information.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cbfdfd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnceAMarine_copyright.vue
// module id = 63
// module chunks = 0